import { Enums } from '../common/enums'
import { Utils } from '../util/utils'

import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'


export class OpCardControl extends OpDashboardControl {
    //Properties
    public header: string
    public text: string
    public image: OpFile
    public backgroundColor: string
    public referenceType: Enums.ReferenceType
    public referenceValue: any
    public option: Enums.DashboardCardOptions
    //Properties end

    //NavigationProperties
    public textHeader: OpDescr
    //NavigationProperties end

    constructor(opObj: any) {
        super(opObj)
        if (opObj) {
            this.width = opObj.Width
            this.header = opObj.Header
            this.text = opObj.Text
            if (opObj.BackgroundColor)
                this.backgroundColor = Utils.getHexColorFromSystemDrawingColor(opObj.BackgroundColor)
            this.referenceType = opObj.ReferenceType
            this.referenceValue = opObj.ReferenceValue
            this.option = opObj.Option
            if (opObj.Image)
                this.image = new OpFile(opObj.Image)
        }
    }
}